"use strict";
exports.__esModule = true;
exports.getCameraFromLatLngs = void 0;
var Camera_1 = require("../../renderer/Camera");
exports.getCameraFromLatLngs = function (points, pixelWidth, maxZoom) {
    if (maxZoom === void 0) { maxZoom = 15; }
    if (!points || !points.length)
        return Camera_1.defaultCamera;
    var _a = points.reduce(function (acc, it) {
        var ne = { lat: acc.ne.lat === 0 ? it.lat : Math.max(it.lat, acc.ne.lat), lng: acc.ne.lng === 0 ? it.lng : Math.max(it.lng, acc.ne.lng) };
        var sw = { lat: acc.ne.lat === 0 ? it.lat : Math.min(it.lat, acc.sw.lat), lng: acc.sw.lng === 0 ? it.lng : Math.min(it.lng, acc.sw.lng) };
        return {
            ne: ne,
            sw: sw,
            center: {
                lat: (ne.lat - sw.lat) / 2 + sw.lat,
                lng: (ne.lng - sw.lng) / 2 + sw.lng
            }
        };
    }, { ne: { lat: 0, lng: 0 }, sw: { lat: 0, lng: 0 }, center: { lat: 0, lng: 0 } }), ne = _a.ne, sw = _a.sw, center = _a.center;
    var angle = ne.lng - sw.lng;
    if (angle < 0)
        angle += 360;
    var zoom = Math.round(Math.log(pixelWidth * 360 / angle / 256) / Math.LN2);
    return {
        center: { lat: center.lat, lng: center.lng },
        zoom: Math.min(zoom - 1, maxZoom)
    };
};
